/* AGC Sticky Coordination â€” coordinates sticky ATC bar, WhatsApp widget, and cookie consent
 * via IntersectionObserver + ResizeObserver. Phase 0 â€” W11 â€” see plan v1.2.
 *
 * Z-index hierarchy (highest first):
 *   cookie consent  : 10000
 *   modals/drawers  :  9000
 *   sticky ATC bar  :  8500
 *   WhatsApp widget :  8000
 *   sticky header   :  7000
 *
 * Behaviour:
 *  - When sticky ATC is visible (intersects viewport bottom), WhatsApp widget translates up by
 *    (stickyATCHeight + 12px) so the two never overlap.
 *  - When the cookie consent bar is present, both widgets shift up by its height as well.
 *  - Combined sticky elements stay <= 25% of mobile viewport height.
 *  - WhatsApp widget supports a 7-day localStorage dismissal flag (`agc_wa_dismissed`).
 *
 * Selectors are intentionally permissive so this module works across the live theme + dev theme.
 * Any of these can be present (or absent) and the module degrades gracefully.
 */
(function (root) {
  'use strict';
  if (root.__agcStickyCoordLoaded) return;
  root.__agcStickyCoordLoaded = true;

  var DISMISS_KEY = 'agc_wa_dismissed';
  var DISMISS_DAYS = 7;
  var GAP_PX = 12;
  var MAX_VIEWPORT_PCT = 0.25;

  var Z = {
    cookie: 10000,
    modal: 9000,
    stickyAtc: 8500,
    whatsapp: 8000,
    header: 7000,
  };

  var STICKY_ATC_SELECTORS = [
    '[data-agc-sticky-atc]',
    '.agc-sticky-atc',
    '.product-sticky-add-to-cart',
    '.sticky-add-to-cart',
    '#sticky-add-to-cart',
  ];
  var WHATSAPP_SELECTORS = [
    '[data-agc-whatsapp]',
    '.agc-whatsapp-widget',
    '.whatsapp-chat-widget',
    '.gallabox-whatsapp-widget',
    '#whatsapp-widget',
  ];
  var COOKIE_SELECTORS = [
    '[data-agc-cookie-consent]',
    '.cookie-consent',
    '#cookie-consent',
    '.optimonk-cookie',
    '#shopify-pc__banner',
  ];

  function pickFirst(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // 7-day dismissal helpers
  function isWhatsappDismissed() {
    try {
      var raw = localStorage.getItem(DISMISS_KEY);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      if (!ts) return false;
      var ms = DISMISS_DAYS * 24 * 60 * 60 * 1000;
      return (Date.now() - ts) < ms;
    } catch (e) { return false; }
  }
  function dismissWhatsapp() {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) {}
  }

  // Coordination state
  var STATE = {
    stickyAtcEl: null,
    whatsappEl: null,
    cookieEl: null,
    stickyAtcVisible: false,
    stickyAtcHeight: 0,
    cookieHeight: 0,
  };

  function applyZIndex(el, z) {
    if (!el) return;
    var current = parseInt(getComputedStyle(el).zIndex, 10);
    if (isNaN(current) || current < z) {
      el.style.zIndex = String(z);
    }
  }

  function measure() {
    if (STATE.stickyAtcEl) {
      var r = STATE.stickyAtcEl.getBoundingClientRect();
      STATE.stickyAtcHeight = STATE.stickyAtcVisible ? r.height : 0;
    } else {
      STATE.stickyAtcHeight = 0;
    }
    if (STATE.cookieEl && STATE.cookieEl.offsetParent !== null) {
      STATE.cookieHeight = STATE.cookieEl.getBoundingClientRect().height;
    } else {
      STATE.cookieHeight = 0;
    }
  }

  function reposition() {
    measure();
    var totalShift = 0;
    if (STATE.stickyAtcVisible) totalShift += STATE.stickyAtcHeight + GAP_PX;
    if (STATE.cookieHeight > 0) totalShift += STATE.cookieHeight;

    // Cap combined sticky elements to MAX_VIEWPORT_PCT of viewport height.
    var maxStack = Math.floor(window.innerHeight * MAX_VIEWPORT_PCT);
    var stackHeight = STATE.stickyAtcHeight + STATE.cookieHeight;
    if (stackHeight > maxStack && STATE.whatsappEl) {
      // Hide WA widget when stack already eats the budget â€” never let combined > 25vh
      STATE.whatsappEl.style.display = 'none';
      return;
    } else if (STATE.whatsappEl && !isWhatsappDismissed()) {
      STATE.whatsappEl.style.display = '';
    }

    if (STATE.whatsappEl) {
      STATE.whatsappEl.style.transform = totalShift > 0
        ? ('translateY(-' + totalShift + 'px)')
        : '';
      STATE.whatsappEl.style.transition = 'transform .25s ease';
    }
  }

  function setupObservers() {
    // IntersectionObserver on sticky ATC: visible when it intersects viewport bottom.
    if (STATE.stickyAtcEl && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          STATE.stickyAtcVisible = en.isIntersecting && en.intersectionRatio > 0;
          reposition();
        });
      }, { threshold: [0, 0.01, 0.5, 1] });
      io.observe(STATE.stickyAtcEl);
    }

    // ResizeObserver tracks cookie banner height changes.
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { reposition(); });
      if (STATE.cookieEl) ro.observe(STATE.cookieEl);
      if (STATE.stickyAtcEl) ro.observe(STATE.stickyAtcEl);
    }

    window.addEventListener('resize', reposition, { passive: true });
    window.addEventListener('orientationchange', reposition, { passive: true });
    window.addEventListener('scroll', reposition, { passive: true });
  }

  function bindDismissBtn() {
    if (!STATE.whatsappEl) return;
    var btn = STATE.whatsappEl.querySelector('[data-agc-wa-dismiss]') ||
              STATE.whatsappEl.querySelector('.agc-wa-dismiss');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        dismissWhatsapp();
        if (STATE.whatsappEl) STATE.whatsappEl.style.display = 'none';
      });
    }
  }

  function init() {
    STATE.stickyAtcEl = pickFirst(STICKY_ATC_SELECTORS);
    STATE.whatsappEl = pickFirst(WHATSAPP_SELECTORS);
    STATE.cookieEl = pickFirst(COOKIE_SELECTORS);

    applyZIndex(STATE.stickyAtcEl, Z.stickyAtc);
    applyZIndex(STATE.whatsappEl, Z.whatsapp);
    applyZIndex(STATE.cookieEl, Z.cookie);

    if (STATE.whatsappEl && isWhatsappDismissed()) {
      STATE.whatsappEl.style.display = 'none';
    }

    bindDismissBtn();
    setupObservers();
    reposition();
  }

  // Public API for diagnostics + manual hooks
  root.AGCStickyCoord = {
    init: init,
    reposition: reposition,
    dismissWhatsapp: function () {
      dismissWhatsapp();
      if (STATE.whatsappEl) STATE.whatsappEl.style.display = 'none';
    },
    state: function () { return Object.assign({}, STATE); },
    Z: Z,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section render so dynamic content is picked up.
  if (root.Shopify && root.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})(typeof window !== 'undefined' ? window : this);
